export default {
  path: 'winter-service/report-base',
  name: 'RoadMaintenanceReportBase',
  component: () => import('../views/ReportByVehicle'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
